import React, { useEffect, useState } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { upsellOptions } from './data/copy';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Bullets } from './components/Bullets';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { StickyCta } from './components/StickyCta';
import { Footer } from './components/Footer';
export function App() {
  const [selectedUpsell, setSelectedUpsell] = useState(upsellOptions[0]);
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-abyss font-body text-bone" data-id="element-0" data-mp="28tw5osok2m3z">
      <TopBar selectedUpsell={selectedUpsell} data-id="element-1" data-mp="28sbcb6dz997p" />
      <Hero selectedUpsell={selectedUpsell} data-id="element-2" data-mp="23w4fc33k781w" />
      <main data-id="element-3" data-mp="23v2uj6wqr76z">
        <SocialProof data-id="element-4" data-mp="23ti7s3go4sjo" />
        <Problem data-id="element-5" data-mp="3ik7e6ay3c1o0" />
        <Offer selectedUpsell={selectedUpsell} onSelectUpsell={setSelectedUpsell} data-id="element-6" data-mp="3ikqytzf4l45q" />
        <Solution data-id="element-7" data-mp="3ml1419v3fqjj" />
        <Bullets data-id="element-8" data-mp="3mkhm3t5g125i" />
        <Guarantee selectedUpsell={selectedUpsell} data-id="element-9" data-mp="3mjzrt22ccy08" />
        <Faq data-id="element-10" data-mp="3rcj846sey78q" />
      </main>
      <Footer data-id="element-11" data-mp="3rdaselgk8ijp" />
      <StickyCta selectedUpsell={selectedUpsell} data-id="element-12" data-mp="3rcsyhvhdegey" />
    </div>;
}